<!-- 单个系统 -->
<template>
  <div>
    <el-container
      id="components-layout-demo-top-side-2"
      class="basic-layout"
    >
      <!-- 顶部导航 -->
      <el-header class="header">
        <div>
          <div class="logo">
            <img style="height:60px;" src="~@/assets/img/logo_new.png">
          </div>
          <div class="nav">
            <el-menu
              mode="horizontal"
              class="menu-box el-menu-demo"
              text-color="#666666"
              active-text-color="#666666"
            >
              <template v-for="(item,index) in menuInfo">
                <!-- 没有子菜单 -->
                <el-menu-item
                  v-if="!item.subNodes"
                  :key="index+1"
                  :index="index.toString()"
                  @click="siderClick(item)"
                >
                  <span class="colorF">{{ item.name }}</span>
                </el-menu-item>

                <!-- 有子菜单 -->
                <el-submenu
                  v-else
                  :key="index+1"
                  :index="index.toString()"
                  @click.native="getChild(item)"
                >
                  <template slot="title">
                    <span class="colorF">{{ item.name }}</span>
                  </template>
                  <template v-for="(ite,i) in item.subNodes">
                    <el-menu-item
                      v-if="(grantedPermissions[ite.auth] || !ite.auth) && !ite.subNodes"
                      :key="ite.url"
                      :index="index+'-'+i"
                      @click="siderClick(ite)"
                    >
                      {{ ite.name }}
                    </el-menu-item>
                    <el-submenu
                      v-if="(grantedPermissions[ite.auth] || !ite.auth) && ite.subNodes"
                      :key="ite.url"
                      :index="index+'-'+i"
                    >
                      <template slot="title">
                        <span>{{ ite.name }}</span>
                      </template>
                      <template v-for="(ite2,j) in ite.subNodes">
                        <el-menu-item
                          v-if="(grantedPermissions[ite2.auth] || !ite2.auth)"
                          :key="ite2.url"
                          :index="index+'-'+j"
                          @click="siderClick(ite2)"
                        >
                          {{ ite2.name }}
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                </el-submenu>
              </template>
            </el-menu>
          </div>
        </div>
        <div class="topRight">

          <!-- 事件 -->
          <el-tooltip content="任务" placement="bottom" effect="light">
            <el-link @click="handleEvent()">
              <i class="el-icon-set-up img-icon" />
            </el-link>
          </el-tooltip>
          <!-- 日程 -->
          <el-tooltip content="日程" placement="bottom" effect="light">
            <el-link @click="handleCalendar()">
              <i class="el-icon-date img-icon" />
            </el-link>
          </el-tooltip>
          <!-- 通知 -->
          <el-tooltip content="通知" placement="bottom" effect="light">
            <el-link @click="handleNotice()">
              <i class="el-icon-chat-dot-round img-icon" />
            </el-link>
          </el-tooltip>
          <template>
            <router-link to="/gr/profile">
              <el-avatar
                v-if="!userImg"
                icon="el-icon-user-solid"
              />
              <el-avatar
                v-if="userImg"
                :src="userImg"
              />
            </router-link>
            <router-link to="/gr/profile" style="padding-top:2px">
              <span class="nickName">{{ nickName }}</span>
            </router-link>
          </template>
          <el-link :underline="false" class="nickName" style="margin-right:10px" @click="handleChangeRole">@{{ selectedUserIdentityName }}</el-link>
          <el-link
            :underline="false"
            class="li"
            @click="logout"
          >
            退出
          </el-link>
        </div>
      </el-header>

      <!-- 侧边栏+内容 -->
      <el-container>
        <!-- 侧边栏 -->
        <el-aside
          v-model="collapsed"
          width="200px"
          menu-trigger="click"
          style="overflow: hidden"
        >
          <el-menu
            class="el-menu-vertical-demo"
            menu-trigger="click"
            :open-keys.sync="openKeys"
            :style="{ overflowY: 'auto', paddingBottom: '48px', height: '100%' }"
          >
            <template v-for="(item,index) in menuInfo">
              <!-- 没有子菜单 -->
              <el-menu-item
                v-if="!item.subNodes"
                :key="index+1"
                :index="index.toString()"
                @click="siderClick(item)"
              >
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>

              <!-- 有子菜单 -->
              <el-submenu
                v-else
                :key="index+1"
                :index="index.toString()"
              >
                <template slot="title">
                  <i :class="item.menuIcon" />
                  <span>{{ item.name }}</span>
                </template>

                <el-menu-item-group>
                  <template v-for="(ite,i) in item.subNodes">
                    <el-menu-item
                      v-if="(grantedPermissions[ite.auth] || !ite.auth) && !ite.subNodes"
                      :key="ite.url"
                      :index="index+'-'+i"
                      @click="siderClick(ite)"
                    >
                      {{ ite.name }}
                    </el-menu-item>
                    <el-submenu
                      v-if="(grantedPermissions[ite.auth] || !ite.auth) && ite.subNodes"
                      :key="ite.url"
                      :index="index+'-'+i"
                    >
                      <template slot="title">
                        <span>{{ ite.name }}</span>
                      </template>
                      <template v-for="(ite2,j) in ite.subNodes">
                        <el-menu-item
                          v-if="(grantedPermissions[ite2.auth] || !ite2.auth)"
                          :key="ite2.url"
                          :index="index+'-'+j"
                          @click="siderClick(ite2)"
                        >
                          {{ ite2.name }}
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                </el-menu-item-group>
              </el-submenu>
            </template>
          </el-menu>
        </el-aside>

        <!-- 内容 -->

        <!-- 主要内容 -->
        <el-main
          class="main"
          :style="{ background: '#fff', minHeight: minLayoutHeight }"
        >
          <!-- <multi-tab></multi-tab> -->
          <breadcrumb />
          <transition name="page-transition">
            <route-view />
          </transition>
        </el-main>
      </el-container>
      <!-- 底部 -->
      <el-footer :style="{ textAlign: 'center' }">
        management-system ©2019 Created by
      </el-footer>
    </el-container>
    <SelectRole v-model="selectRoleShow" :sel-val="selectedUserIdentity" @success="getCurrentLoginInformations" />
  </div>
</template>

<script>

import RouteView from './RouteView'
import comInfo from './Config'
import pathReq from '../api/pathlist'
import breadcrumb from '../components/Breadcrumb'
import SelectRole from '@/views/Home/SelectRole.vue'

import config from '@/config'

export default {
  components: {
    RouteView,
    breadcrumb, SelectRole

    // ChangePassword,
  },
  data() {
    return {
      selectRoleShow: false,
      collapsed: false, // 侧边栏是否收起
      multiTab: true,
      slideMenus: [], // 左侧菜单
      // defaultHeaderSelectedKeys: '', // 顶部导航默认值
      siderDefaultSelectedKeys: [this.$route.path],
      openKeys: [],
      apiZTree: {}, // 存储所有菜单
      isLogin: false,
      menuInfo: comInfo.menuInfo,
      grantedPermissions: '',
      baseURL: config.apiHost,
      userImg: '',
      nickName: '',
      selectedUserIdentity: null,
      selectedUserIdentityName: ''
    }
  },
  computed: {
    // 左边菜单栏
    // menuList() {
    //   const ret = this.apiZTree.nodes;
    //   return ret;
    // },
    // 内容区域最小高度
    minLayoutHeight() {
      let ret = 280
      ret = window.innerHeight - 64 - 70 - 10 - 10
      return `${ret}px`
    },
    // 用户信息
    userName() {
      const ret = sessionStorage.getItem('user-data')
      return ret
    }
  },
  watch: {
    $route(newVal) {
      if (newVal.path !== '/') {
        this.siderDefaultSelectedKeys = [newVal.path] // 侧边栏选中
      } else {
        this.siderDefaultSelectedKeys = []
      }

      this.checkLinkOauth()
    },
    menuPath() {
      this.checkLinkOauth()
    }
  },
  created() {
    // 没有登录
    this.isLogin = sessionStorage.getItem('isLogin') || window.localStorage.getItem('isLogin')
    // this.nickName = sessionStorage.getItem('nickName');
    if (!this.isLogin) {
      this.logout()
    }
    this._data.grantedPermissions = JSON.parse(sessionStorage.getItem('grantedPermissions')) || JSON.parse(window.localStorage.getItem('grantedPermissions'))
    this.defaultSelectedKeys = sessionStorage.getItem('logout-path')

    // 侧边栏打开选项
    if (
      this.siderDefaultSelectedKeys &&
      this.$route.matched[1] &&
      this.$route.matched[1].name
    ) {
      this.openKeys = [this.$route.matched[1].name]
    }

    this.checkLinkOauth() // 路由跳转控制
    this.getAll()
    this.getCurrentLoginInformations()
  },
  mounted() { },
  methods: {
    // 退出
    logout() {
      this.$confirm('确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.setItem('logout-path', this.$route.path)
        localStorage.removeItem('accessToken')
        localStorage.removeItem('encryptedAccessToken')
        localStorage.removeItem('isLogin')
        localStorage.removeItem('userId')

        this.$nextTick(() => {
          this.$router.push('/')
        })
      })
    },

    // 获取信息
    getAll() {
      const path = '/AbpUserConfiguration/GetAll'
      pathReq.postForm(path).then((res) => {
        if (res.status === 200) {
          // console.log(res.data);
          if (res.data.success) {
            const grantedPermissions = JSON.stringify(res.data.result.auth.grantedPermissions)
            sessionStorage.setItem('grantedPermissions', grantedPermissions)
            window.localStorage.setItem('grantedPermissions', grantedPermissions)
          }
        }
      })
    },

    // 获取用户信息
    getCurrentLoginInformations() {
      const that = this
      const path = '/api/services/app/Session/GetCurrentLoginInformations'
      pathReq.getNoParams(path).then((res) => {
        if (res.status === 200) {
          if (res.data.success) {
            if (res.data.result.user != null) {
              const nickName = res.data.result.user.nickName
              this._data.nickName = nickName

              const name = res.data.result.user.selectedUserIdentityName
              const nameArr = name.split('/')
              if (nameArr.length > 0) {
                that.selectedUserIdentityName = nameArr[nameArr.length - 1]
              } else {
                that.selectedUserIdentityName = ''
              }
              window.localStorage.setItem('nickName', nickName)
              this.userImg = this.baseURL + '/api/EndUserInfo/LoadUserImage?userId=' + res.data.result.user.id
              this.selectedUserIdentity = res.data.result.user.selectedUserIdentity
            } else {
              this.isLogin = false
            }
          }
        }
      })
    },

    // 跳导航
    getChild(item) {
      console.log(item)
      this.$router.push({ name: 'navi', query: { 'naviInfo': JSON.stringify(item) }})
    },

    /** 事件 */
    handleEvent() {
      this.$router.push({ name: 'evenement' })
    },
    /** 日历 */
    handleCalendar() {
      this.$router.push({ name: 'calendar' })
    },
    /** 通知 */
    handleNotice() {
      this.$router.push({ name: 'notice' })
    },
    // // 点击顶部系统导航
    // headerMenusClick(item) {
    //   this.getSiderMenu(item.key);
    //   if (item.key) {
    //     this.$router.push("/");
    //   }
    // },
    // getSiderMenu(code) {
    //   CommonApi.getZMenu(code).then(res => {
    //     if (res.data.zTree) {
    //       this.apiZTree[code] = res.data;
    //       sessionStorage.setItem("zMenu", JSON.stringify(this.apiZTree));
    //       this.apiZTree = JSON.parse(sessionStorage.getItem("zMenu")) || {};
    //     }
    //   });
    // },
    // 点击侧边栏
    siderClick(item) {
      // console.log(item);
      // this.openKeys=item.keyPath[];

      this.$router.push(item.path)
    },
    // 修改密码
    changePassword() {
      this.$bus.$emit('change/password')
    },
    // handleChangeRole 切换身份
    handleChangeRole() {
      this.selectRoleShow = true
    },
    //  链接地址的权限判断
    checkLinkOauth() {
      // if (
      //   this.$route.path !== '/' &&
      //   this.menuPath.indexOf(this.$route.path) < 0
      // ) {
      //   this.$router.push({ path: '/403' });
      // }
    }
  }
}
</script>
<style scoped>
.header {
  height: auto !important;
  position: relative;
  z-index: 99;
  background: url("~@/assets/img/menu_bg.png") no-repeat left top;
  background-size:100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 10px 20px;
  min-width: 1100px;
}
.main {
  min-width: 1100px;
}

.logo {
  width: 114px;
  float: left;
  text-align: center;
}
.logo img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}

.topRight {
  float: right;
  vertical-align: middle;
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #fff;
}

.topRight .li {
  margin-left: 10px;
}
.img-icon {
  width: 30px;
  font-size: 30px;
  margin-right: 10px;
}
.nav {
  padding-left: 30px;
  float: left;
  font-size: 16px;
}

.nav .el-menu--horizontal {
  border: none;
}
.menu-box {
  background: none;

  font-size: 16px;
}

.menu-box a {
  color: #666;
  background: none;
}

.nickName {
  margin-left: 5px;
  color: #666;
  line-height: 40px;
  font-weight: bold;
}
</style>
